import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label,TextArea,Dropdown,Message } from 'semantic-ui-react'
import Cleave from 'cleave.js/react'
import Paginations from '../../../config/pagination'
import EntryList from '../../../config/entries'
import {WindowReload, WindowURLClient, WindowLocationClient} from '../../../config/settings'
import Alertmessage from '../../../config/alert'
import axios from 'axios'
import renderHTML from 'react-render-html'
import {insertvalidations} from './validate'


export default function TradeOrderComponent(props) {

	const [alert,setalert] = useState(false);
	const [Alertcontent,setAlertcontent] = useState({});
	function Alertclose(){setalert(false);}
	function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
	function Alertdelete(data){
		if(data.delete==true){
		}
	}


	/*-------------------------------------------------------------------------
	 Forms: Adding and Updating
	--------------------------------------------------------------------------*/
	const [tdetails, settdetails] = useState('Buy 5x CALL PR:1,000.00');
	const [state,setstate] = useState({
		trade_order:'Buy',
		trade_position:5,
		trade_option:'Call',
		trade_commodity:'',
		trade_contract:'G14 (28 Jan 14)',
		strike_price:'',
		premium:'1.00',
		contract:'1,000',
		price:'1,000.00',
		trade_value:'0.00',
		trade_fees:'35.00',
		trade_invoice:'0.00',
	});
	function handleSubmitForm(values, props){

		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);

		let formData = new FormData();
		formData.append('type','send_order');
		formData.append('info',JSON.stringify(values));
		axios.post('/client/tradeorder/http.php',formData)
		.then(function (response) {

			let obj = response.data;

			if(obj=='success'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'success',title:'Congratulations',html:"Trade order request successfully send."}});
				setalert(true);
				setTimeout(function() {WindowReload();},2000);
				return false;
			}

			if(obj=='error'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'error',title:'Saving Error!',html:"Trade order request not successfully send. Please try again later.",footer:'yes'}});
				setalert(true);
				setTimeout(function() {WindowReload();},2000);
				return false;
			}

			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Input Error!',html:"Please correct the input errors.",footer:'yes'}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
			Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
			setalert(true);
			setTimeout(function() {WindowReload();},2000);
		});
	}

  const [TradeOrder, setTradeOrder] = useState([]);
	const [TradePosition, setTradePosition] = useState([]);
	const [TradeOptions, setTradeOptions] = useState([]);
	const [TradeContract, setTradeContract] = useState([]);

	const [CommodityCurrencies, setCommodityCurrencies] = useState([]);
	const [CommodityMetals, setCommodityMetals] = useState([]);
	const [CommodityEnergies, setCommodityEnergies] = useState([]);
	const [CommodityFinancial, setCommodityFinancial] = useState([]);

	const [CommodityIndices, setCommodityIndices] = useState([]);
	const [CommodityGrains, setCommodityGrains] = useState([]);
	const [CommodityMeats, setCommodityMeats] = useState([]);
	const [CommoditySofts, setCommoditySofts] = useState([]);

	const [CommodityEuroGrains, setCommodityEuroGrains] = useState([]);
	const [CommodityEuroIndices, setCommodityEuroIndices] = useState([]);
	const [CommodityEuroFinancial, setCommodityEuroFinancial] = useState([]);
	const [CommodityEuroSofts, setCommodityEuroSofts] = useState([]);


	function SelectionTrade(){
		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);

		let formData = new FormData();
		formData.append('type','trade_selection');
		axios.post('/client/tradeorder/http.php',formData)
		.then(function (response) {
			let obj = response.data;

			setTradeOrder(obj.TradeOrder);
			setTradePosition(obj.TradePosition);
			setTradeOptions(obj.TradeOptions);
			setTradeContract(obj.TradeContract);

			setCommodityCurrencies(obj.CommodityCurrencies);
			setCommodityMetals(obj.CommodityMetals);
			setCommodityEnergies(obj.CommodityEnergies);
			setCommodityFinancial(obj.CommodityFinancial);

			setCommodityIndices(obj.CommodityIndices);
			setCommodityGrains(obj.CommodityGrains);
			setCommodityMeats(obj.CommodityMeats);
			setCommoditySofts(obj.CommoditySofts);

			setCommodityEuroGrains(obj.CommodityEuroGrains);
			setCommodityEuroIndices(obj.CommodityEuroIndices);
			setCommodityEuroFinancial(obj.CommodityEuroFinancial);
			setCommodityEuroSofts(obj.CommodityEuroSofts);

			setalert(false);
		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
			setalert(true);
			setTimeout(function() {WindowReload();},2000);
		});
	}


	useEffect(()=>{
		SelectionTrade();
	},[]);


	return (
		<React.Fragment>
      <div className="page-wrapper">
				{alert&&<Alertmessage close={Alertclose} data={Alertcontent} confirm={Alertconfirm} delete={Alertdelete}/>}
				<Form className="uitrade">
					<Formik
					  enableReinitialize
						initialValues={state}
						validationSchema={insertvalidations}
						onSubmit={handleSubmitForm}
						render={formProps => {
						const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps


						return(
			         <div className="panel">
			            <div className="panel-header">Trade Order</div>
			            <div className="panel-body">

									 <div className="formtwo-wrapper">

									 		<div>{/*----------------left column--------------------------------------*/}


												<div className="inlinformtwo">
													<div><label>Trade Order</label></div>
													<div>
													<Form.Group widths="equal">
														<Field name="trade_order">
																{({ field, form }) => (
																<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																 <Select selectOnBlur={false}
																		{...field}
																		options={TradeOrder}
																		onChange={(e, { value }) => {
																			settdetails(value+' '+values.trade_position+'x '+ values.trade_option+' '+values.trade_commodity+' PR:'+values.contract);
																			setFieldValue(field.name,value);
																		}}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
																)}
														</Field>
													</Form.Group>
													</div>
											 </div>{/*.inlinform*/}

											 <div className="inlinformtwo">
												 <div><label>Positions</label></div>
												 <div>
												 <Form.Group widths="equal">
													 <Field name="trade_position">
															 {({ field, form }) => (
															 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<Select selectOnBlur={false}
																	 {...field}
																	 options={TradePosition}
																	 onChange={(e, { value }) => {

																		 settdetails(values.trade_order+' '+value+'x '+ values.trade_option+' '+values.trade_commodity+' PR:'+values.contract);

																		 var quantity = parseInt(value);
																		 var price 		= parseFloat(values.price.replace(/,/g, ''));

																		 var tradevalue = quantity*price;
																		 var tradeinvoice = parseInt(values.trade_fees);
																		 setFieldValue('trade_value',tradevalue.toFixed(2));
																		 setFieldValue('trade_invoice',(tradevalue+tradeinvoice).toFixed(2));
																		 setFieldValue(field.name,value);

																	 }}/>
																 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															 </Form.Field>
															 )}
													 </Field>
												 </Form.Group>
												 </div>
											</div>{/*.inlinform*/}

											<div className="inlinformtwo">
												<div><label>Option</label></div>
												<div>
												<Form.Group widths="equal">
													<Field name="trade_option">
															{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <Select selectOnBlur={false}
																	{...field}
																	options={TradeOptions}
																	onChange={(e, { value }) => {
																		settdetails(values.trade_order+' '+values.trade_position+'x '+ value+' '+values.trade_commodity+' PR:'+values.contract);
																		setFieldValue(field.name,value);
																	}}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>
												</div>
										   </div>{/*.inlinform*/}


											  <div className="inlinformtwo">
	 											<div><label>Commodity</label></div>
	 											<div>
												<Form.Group widths="equal">
													<Field name="trade_commodity">
															{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Dropdown
																 fluid
																 selection
																 text={values.trade_commodity}
															>
															<Dropdown.Menu>

																{/*Currencies*/}
																<Dropdown.Header icon='dot circle outline' content='Currencies' />
																<Dropdown.Divider />
																{CommodityCurrencies.map(function(data, key){
			 													 return<Dropdown.Item key={key} onClick={()=>{

																	 setFieldValue('primium', data.primium);
																	 setFieldValue('price', data.price);
																	 setFieldValue('contract', data.contract);
																	 setFieldValue('trade_commodity', data.name);

																	 var quantity = parseInt(values.trade_position);
																	 var price 		= parseFloat(data.price.replace(/,/g, ''));

																	 var tradevalue = quantity*price;
																	 var tradeinvoice = parseInt(values.trade_fees);
																	 setFieldValue('trade_value',tradevalue.toFixed(2));
																	 setFieldValue('trade_invoice',(tradevalue+tradeinvoice).toFixed(2));

																	 settdetails(values.trade_order+' '+values.trade_position+'x '+ values.trade_option+' '+data.name+' PR:'+data.contract);


																 }}>{data.name}</Dropdown.Item>})}

																 {/*Metals*/}
	 															<Dropdown.Header icon='dot circle outline' content='Metals' />
	 															<Dropdown.Divider />
	 															{CommodityMetals.map(function(data, key){
	 		 													 return<Dropdown.Item key={key} onClick={()=>{

																	 setFieldValue('primium', data.primium);
																	 setFieldValue('price', data.price);
																	 setFieldValue('contract', data.contract);
																	 setFieldValue('trade_commodity', data.name);

																	 var quantity = parseInt(values.trade_position);
																	 var price 		= parseFloat(data.price.replace(/,/g, ''));

																	 var tradevalue = quantity*price;
																	 var tradeinvoice = parseInt(values.trade_fees);
																	 setFieldValue('trade_value',tradevalue.toFixed(2));
																	 setFieldValue('trade_invoice',(tradevalue+tradeinvoice).toFixed(2));

																	 settdetails(values.trade_order+' '+values.trade_position+'x '+ values.trade_option+' '+data.name+' PR:'+data.contract);


	 															 }}>{data.name}</Dropdown.Item>})}

																 {/*Energies*/}
	 															<Dropdown.Header icon='dot circle outline' content='Energies' />
	 															<Dropdown.Divider />
	 															{CommodityEnergies.map(function(data, key){
	 		 													 return<Dropdown.Item key={key} onClick={()=>{

																	 setFieldValue('primium', data.primium);
																	 setFieldValue('price', data.price);
																	 setFieldValue('contract', data.contract);
																	 setFieldValue('trade_commodity', data.name);

																	 var quantity = parseInt(values.trade_position);
																	 var price 		= parseFloat(data.price.replace(/,/g, ''));

																	 var tradevalue = quantity*price;
																	 var tradeinvoice = parseInt(values.trade_fees);
																	 setFieldValue('trade_value',tradevalue.toFixed(2));
																	 setFieldValue('trade_invoice',(tradevalue+tradeinvoice).toFixed(2));

																	 settdetails(values.trade_order+' '+values.trade_position+'x '+ values.trade_option+' '+data.name+' PR:'+data.contract);

	 															 }}>{data.name}</Dropdown.Item>})}

																 {/*Financial*/}
	 															<Dropdown.Header icon='dot circle outline' content='Financial' />
	 															<Dropdown.Divider />
	 															{CommodityFinancial.map(function(data, key){
	 		 													 return<Dropdown.Item key={key} onClick={()=>{

																	 setFieldValue('primium', data.primium);
																	 setFieldValue('price', data.price);
																	 setFieldValue('contract', data.contract);
																	 setFieldValue('trade_commodity', data.name);

																	 var quantity = parseInt(values.trade_position);
																	 var price 		= parseFloat(data.price.replace(/,/g, ''));

																	 var tradevalue = quantity*price;
																	 var tradeinvoice = parseInt(values.trade_fees);
																	 setFieldValue('trade_value',tradevalue.toFixed(2));
																	 setFieldValue('trade_invoice',(tradevalue+tradeinvoice).toFixed(2));

																	 settdetails(values.trade_order+' '+values.trade_position+'x '+ values.trade_option+' '+data.name+' PR:'+data.contract);

	 															 }}>{data.name}</Dropdown.Item>})}

																 {/*Indices*/}
	 															<Dropdown.Header icon='dot circle outline' content='Indices' />
	 															<Dropdown.Divider />
	 															{CommodityIndices.map(function(data, key){
	 		 													 return<Dropdown.Item key={key} onClick={()=>{

																	 setFieldValue('primium', data.primium);
																	 setFieldValue('price', data.price);
																	 setFieldValue('contract', data.contract);
																	 setFieldValue('trade_commodity', data.name);

																	 var quantity = parseInt(values.trade_position);
																	 var price 		= parseFloat(data.price.replace(/,/g, ''));

																	 var tradevalue = quantity*price;
																	 var tradeinvoice = parseInt(values.trade_fees);
																	 setFieldValue('trade_value',tradevalue.toFixed(2));
																	 setFieldValue('trade_invoice',(tradevalue+tradeinvoice).toFixed(2));

																	 settdetails(values.trade_order+' '+values.trade_position+'x '+ values.trade_option+' '+data.name+' PR:'+data.contract);

	 															 }}>{data.name}</Dropdown.Item>})}

																 {/*Grains and Oilseed*/}
																 <Dropdown.Header icon='dot circle outline' content='Grains and Oilseeds' />
																 <Dropdown.Divider />
																 {CommodityGrains.map(function(data, key){
																	return<Dropdown.Item key={key} onClick={()=>{

																	 setFieldValue('primium', data.primium);
 																	 setFieldValue('price', data.price);
 																	 setFieldValue('contract', data.contract);
 																	 setFieldValue('trade_commodity', data.name);

 																	 var quantity = parseInt(values.trade_position);
 																	 var price 		= parseFloat(data.price.replace(/,/g, ''));

 																	 var tradevalue = quantity*price;
 																	 var tradeinvoice = parseInt(values.trade_fees);
 																	 setFieldValue('trade_value',tradevalue.toFixed(2));
 																	 setFieldValue('trade_invoice',(tradevalue+tradeinvoice).toFixed(2));

																	 settdetails(values.trade_order+' '+values.trade_position+'x '+ values.trade_option+' '+data.name+' PR:'+data.contract);

																	}}>{data.name}</Dropdown.Item>})}

																	{/*Meats*/}
	 															 <Dropdown.Header icon='dot circle outline' content='Meats' />
	 															 <Dropdown.Divider />
	 															 {CommodityGrains.map(function(data, key){
	 																return<Dropdown.Item key={key} onClick={()=>{

																	 setFieldValue('primium', data.primium);
 																	 setFieldValue('price', data.price);
 																	 setFieldValue('contract', data.contract);
 																	 setFieldValue('trade_commodity', data.name);

 																	 var quantity = parseInt(values.trade_position);
 																	 var price 		= parseFloat(data.price.replace(/,/g, ''));

 																	 var tradevalue = quantity*price;
 																	 var tradeinvoice = parseInt(values.trade_fees);
 																	 setFieldValue('trade_value',tradevalue.toFixed(2));
 																	 setFieldValue('trade_invoice',(tradevalue+tradeinvoice).toFixed(2));

																	 settdetails(values.trade_order+' '+values.trade_position+'x '+ values.trade_option+' '+data.name+' PR:'+data.contract);

	 																}}>{data.name}</Dropdown.Item>})}

																	{/*Softs*/}
	 															 <Dropdown.Header icon='dot circle outline' content='Softs' />
	 															 <Dropdown.Divider />
	 															 {CommoditySofts.map(function(data, key){
	 																return<Dropdown.Item key={key} onClick={()=>{

																		setFieldValue('primium', data.primium);
 																	 setFieldValue('price', data.price);
 																	 setFieldValue('contract', data.contract);
 																	 setFieldValue('trade_commodity', data.name);

 																	 var quantity = parseInt(values.trade_position);
 																	 var price 		= parseFloat(data.price.replace(/,/g, ''));

 																	 var tradevalue = quantity*price;
 																	 var tradeinvoice = parseInt(values.trade_fees);
 																	 setFieldValue('trade_value',tradevalue.toFixed(2));
 																	 setFieldValue('trade_invoice',(tradevalue+tradeinvoice).toFixed(2));

																	 settdetails(values.trade_order+' '+values.trade_position+'x '+ values.trade_option+' '+data.name+' PR:'+data.contract);

	 																}}>{data.name}</Dropdown.Item>})}

																	{/*European Grains*/}
	 															 <Dropdown.Header icon='dot circle outline' content='European Grains' />
	 															 <Dropdown.Divider />
	 															 {CommodityEuroGrains.map(function(data, key){
	 																return<Dropdown.Item key={key} onClick={()=>{

																		setFieldValue('primium', data.primium);
 																	 setFieldValue('price', data.price);
 																	 setFieldValue('contract', data.contract);
 																	 setFieldValue('trade_commodity', data.name);

 																	 var quantity = parseInt(values.trade_position);
 																	 var price 		= parseFloat(data.price.replace(/,/g, ''));

 																	 var tradevalue = quantity*price;
 																	 var tradeinvoice = parseInt(values.trade_fees);
 																	 setFieldValue('trade_value',tradevalue.toFixed(2));
 																	 setFieldValue('trade_invoice',(tradevalue+tradeinvoice).toFixed(2));

																	 settdetails(values.trade_order+' '+values.trade_position+'x '+ values.trade_option+' '+data.name+' PR:'+data.contract);

	 																}}>{data.name}</Dropdown.Item>})}

																	{/*European Indices*/}
	 															 <Dropdown.Header icon='dot circle outline' content='European Indices' />
	 															 <Dropdown.Divider />
	 															 {CommodityEuroIndices.map(function(data, key){
	 																return<Dropdown.Item key={key} onClick={()=>{

																		setFieldValue('primium', data.primium);
 																	 setFieldValue('price', data.price);
 																	 setFieldValue('contract', data.contract);
 																	 setFieldValue('trade_commodity', data.name);

 																	 var quantity = parseInt(values.trade_position);
 																	 var price 		= parseFloat(data.price.replace(/,/g, ''));

 																	 var tradevalue = quantity*price;
 																	 var tradeinvoice = parseInt(values.trade_fees);
 																	 setFieldValue('trade_value',tradevalue.toFixed(2));
 																	 setFieldValue('trade_invoice',(tradevalue+tradeinvoice).toFixed(2));

																	 settdetails(values.trade_order+' '+values.trade_position+'x '+ values.trade_option+' '+data.name+' PR:'+data.contract);

	 																}}>{data.name}</Dropdown.Item>})}

																	{/*European Financial*/}
	 															 <Dropdown.Header icon='dot circle outline' content='European Financial' />
	 															 <Dropdown.Divider />
	 															 {CommodityEuroFinancial.map(function(data, key){
	 																return<Dropdown.Item key={key} onClick={()=>{

																		setFieldValue('primium', data.primium);
 																	 setFieldValue('price', data.price);
 																	 setFieldValue('contract', data.contract);
 																	 setFieldValue('trade_commodity', data.name);

 																	 var quantity = parseInt(values.trade_position);
 																	 var price 		= parseFloat(data.price.replace(/,/g, ''));

 																	 var tradevalue = quantity*price;
 																	 var tradeinvoice = parseInt(values.trade_fees);
 																	 setFieldValue('trade_value',tradevalue.toFixed(2));
 																	 setFieldValue('trade_invoice',(tradevalue+tradeinvoice).toFixed(2));

																	 settdetails(values.trade_order+' '+values.trade_position+'x '+ values.trade_option+' '+data.name+' PR:'+data.contract);

	 																}}>{data.name}</Dropdown.Item>})}

																	{/*European Softs*/}
	 															 <Dropdown.Header icon='dot circle outline' content='European Softs' />
	 															 <Dropdown.Divider />
	 															 {CommodityEuroSofts.map(function(data, key){
	 																return<Dropdown.Item key={key} onClick={()=>{

																	 setFieldValue('primium', data.primium);
 																	 setFieldValue('price', data.price);
 																	 setFieldValue('contract', data.contract);
 																	 setFieldValue('trade_commodity', data.name);

 																	 var quantity = parseInt(values.trade_position);
 																	 var price 		= parseFloat(data.price.replace(/,/g, ''));

 																	 var tradevalue = quantity*price;
 																	 var tradeinvoice = parseInt(values.trade_fees);
 																	 setFieldValue('trade_value',tradevalue.toFixed(2));
 																	 setFieldValue('trade_invoice',(tradevalue+tradeinvoice).toFixed(2));

																	 settdetails(values.trade_order+' '+values.trade_position+'x '+ values.trade_option+' '+data.name+' PR:'+data.contract);

	 																}}>{data.name}</Dropdown.Item>})}

															</Dropdown.Menu>
														</Dropdown>
														{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
													</Form.Field>
													)}
											    </Field>
										    </Form.Group>
	 											</div>
	 									 </div>{/*.inlinform*/}

										 <div className="inlinformtwo">
											 <div><label>Contract</label></div>
											 <div>
											 <Form.Group widths="equal">
												 <Field name="trade_contract">
														 {({ field, form }) => (
														 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Select selectOnBlur={false}
																 {...field}
																 options={TradeContract}
																 onChange={(e, { value }) => {
																	 setFieldValue(field.name,value);
																 }}/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>
											 </div>
											</div>{/*.inlinform*/}


										 <div className="inlinformtwo">
											<div><label>Price Per Share</label></div>
											<div>
											<Form.Group widths="equal">
												<Field name="strike_price">
														{({ field, form }) => (
														<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											</div>
									 </div>{/*.inlinform*/}



									 </div>{/*.------------------------------left column-------------------------------*/}


										<div className="textformright">{/*.-------------------------------right column------------------------------*/}

											<div className="inlinformtwo">
												<div><label>Premium</label></div>
												<div>
												<Form.Group widths="equal">
													<Field name="premium">
															{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<Cleave {...field} options={{numeral: true, numeralThousandsGroupStyle: "thousand", numeralDecimalScale:6}} onChange={handleChange} maxLength="16"/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>
												</div>
										 </div>{/*.inlinform*/}

										 <div className="inlinformtwo">
											 <div><label>Contract Size</label></div>
											 <div>
											 <Form.Group widths="equal">
												 <Field name="contract">
														 {({ field, form }) => (
														 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															 <Cleave {...field} options={{numeral: true, numeralThousandsGroupStyle: "thousand", numeralDecimalScale:6}} onChange={handleChange} maxLength="16" disabled/>
															 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														 </Form.Field>
														 )}
												 </Field>
											 </Form.Group>
											 </div>
										</div>{/*.inlinform*/}

										<div className="inlinformtwo">
											<div><label>Price per Contract</label></div>
											<div>
											<Form.Group widths="equal">
												<Field name="price">
														{({ field, form }) => (
														<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Cleave {...field} options={{numeral: true, numeralThousandsGroupStyle: "thousand", numeralDecimalScale:6}} onChange={(e)=>{

																	var quantity  = parseInt(values.trade_position);
																	var price 		= parseFloat(e.target.value.replace(/,/g, ''));
																	setFieldValue(field.name,e.target.value);

																	if(isNaN(price)){
																		setFieldValue('trade_value','0.00');
																		setFieldValue('trade_invoice','0.00');
																		return false;
																	}

																	var tradevalue = quantity*price;
																	var tradeinvoice = parseInt(values.trade_fees);
																	setFieldValue('trade_value',tradevalue.toFixed(2));
																	setFieldValue('trade_invoice',(tradevalue+tradeinvoice).toFixed(2));


															}} maxLength="16"/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											</div>
									 </div>{/*.inlinform*/}

									 <div className="inlinformtwo">
										 <div><label>Trade Value</label></div>
										 <div>
										 <Form.Group widths="equal">
											 <Field name="trade_value">
													 {({ field, form }) => (
													 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
														 <Cleave {...field} options={{numeral: true, numeralThousandsGroupStyle: "thousand", numeralDecimalScale:6}} onChange={handleChange} maxLength="16" disabled/>
														 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
													 </Form.Field>
													 )}
											 </Field>
										 </Form.Group>
										 </div>
									</div>{/*.inlinform*/}

									<div className="inlinformtwo">
										<div><label>Trade Fees</label></div>
										<div>
										<Form.Group widths="equal">
											<Field name="trade_fees">
													{({ field, form }) => (
													<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
														<Cleave {...field} options={{numeral: true, numeralThousandsGroupStyle: "thousand", numeralDecimalScale:6}} onChange={handleChange} maxLength="16" disabled/>
														{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
													</Form.Field>
													)}
											</Field>
										</Form.Group>
										</div>
								 </div>{/*.inlinform*/}

								 <div className="inlinformtwo">
									 <div><label>Trade Invoiced</label></div>
									 <div>
									 <Form.Group widths="equal">
										 <Field name="trade_invoice">
												 {({ field, form }) => (
												 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
													 <Cleave {...field} options={{numeral: true, numeralThousandsGroupStyle: "thousand", numeralDecimalScale:6}} onChange={handleChange} maxLength="16" disabled/>
													 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
												 </Form.Field>
												 )}
										 </Field>
									 </Form.Group>
									 </div>
								</div>{/*.inlinform*/}


								</div>{/*.------------------------------right column------------------------------*/}

								</div>{/*.end wrapper*/}

								 <div className="trade-message-wrapper">
								 		<div>
										<Message
											success
											visible
											icon='info circle'
											header='Trade Details'
											content={tdetails}
										 />
										</div>
										<div><Message visible success>Trade requests are submitted to your broker for verification. Upon receiving a request, your broker will contact you to verify your trade details.</Message></div>
								 </div>

									</div>{/*.panel-body*/}
			            <div className="panel-footer text-right">
											<Button className='secondary' size='large' icon="send" content='Request Trade' onClick={handleSubmit}/>
									</div>
			         </div>

						 )}}/>
					</Form>



      </div>
    </React.Fragment>
  )
}
